import ProfilePage from './Profile';
import NotFound from 'components/not-found/NotFound';
import HomePage from './Home';
import GroupsFullList from 'components/profile/groups/GroupsFullList';
import Settings from 'components/profile/settings/Settings';
import ErrorPage from './Error';
import BadgesFullList from 'components/profile/main-panel/badges/BadgesFullList';
import EditProfileForm from 'components/profile/edit-profile/EditProfileForm';
import CertificationsFullList from 'components/profile/main-panel/certifications/CertificationsFullList';
import Complete from 'components/profile/settings/Complete';
import Authenticate from 'components/profile/settings/Authenticate';
import Connect from 'components/profile/Connect';

const homeRoute = {
  name: 'home',
  path: '/',
  exact: true,
  component: HomePage,
};

/**
 * As of now, Need to support both /:id and /.
 * /:id is required for vanity url redirection and
 * / is used during within app navigation. This uses session information to obtain aaid.
 */
const groupsRoute = {
  name: 'groups',
  path: '/profile/:pathProfileId/groups',
  exact: true,
  component: GroupsFullList,
};

const badgesRoute = {
  name: 'badges',
  path: '/profile/:pathProfileId/badges',
  exact: true,
  component: BadgesFullList,
};

const connectRoute = {
  name: 'connect',
  path: '/connect/:appname/:id',
  exact: true,
  component: Connect,
};

const certificationsRoute = {
  name: 'certifications',
  path: '/profile/:pathProfileId/certifications',
  exact: true,
  component: CertificationsFullList,
};

const profileRoute = {
  name: 'profile',
  path: '/profile/:pathProfileId',
  exact: true,
  component: ProfilePage,
};

const settingsRoute = {
  name: 'settings',
  path: '/settings',
  exact: true,
  component: Settings,
};

const settingsCompleteRoute = {
  name: 'complete',
  path: '/settings/complete/:token',
  exact: true,
  component: Complete,
};

const authenticateRoute = {
  name: 'authenticate',
  path: '/authenticate/:token',
  exact: true,
  component: Authenticate,
};

const editProfileRoute = {
  name: 'edit-profile',
  path: '/profile/:pathProfileId/edit',
  exact: true,
  component: EditProfileForm,
};

const defaultComponentRoute = {
  name: '404',
  path: '',
  component: NotFound,
};

const errorRoute = {
  name: 'error',
  path: '/error/:errorId',
  exact: true,
  component: ErrorPage,
};

export const appRoutes = [
  homeRoute,
  connectRoute,
  settingsRoute,
  authenticateRoute,
  settingsCompleteRoute,
  profileRoute,
  editProfileRoute,
  certificationsRoute,
  groupsRoute,
  badgesRoute,
  errorRoute,
  defaultComponentRoute,
];
